// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__1tbls","plus":"styles_plus__J_JgM","key":"styles_key___Uz84"};